import * as styles from "./InlineLocationFilters.module.scss";

import { Button, Form } from "../../../components/common";

import React from "react";
import { useOurCentres } from "../../../context";
import { DISTANCE_OPTIONS } from "../../../context/DogSearchApi/DogSearchApi.fixtures";
import LocationInput from "../LocationInput/LocationInput";

export const InlineLocationFilters: React.FC = () => {
	const {
		userLocation,
		currentDistance,
		centresInRange,
		onUpdateLocation,
		onUpdateTravelDistance,
	} = useOurCentres();

	const haveCentresInRange = centresInRange?.length > 0;

	const onClick = () => {
		const offset = document.getElementById("dt-header").offsetHeight + 16;

		window.scrollBy({
			left: 0,
			top:
				document.getElementById("centre-listings").getBoundingClientRect().top -
				offset,
			behavior: "smooth",
		});
	};
	return (
		<div className={styles.inlinefilters}>
			<h2 className={styles.title}>Find your local centre</h2>
			<label htmlFor="location" className={styles.label}>
				Location <span>(Postcode)</span>
			</label>
			<Form onSubmitFn={() => {}} validationSchema={{}}>
				<LocationInput
					name={"location"}
					className={styles.searchinput}
					userLocation={userLocation}
					onClearUserLocation={() => onUpdateLocation(null, 150)}
					onConfirmUserLocation={(location) =>
						onUpdateLocation(location, Math.min(currentDistance, 150))
					}
					placeholder={"All of UK"}
				/>
			</Form>
			<div className={styles.distancecontainer}>
				<label htmlFor="distance-input" className={styles.label}>
					Distance
				</label>
				<fieldset className={styles.distancecontrols}>
					<input
						id="distance-input"
						name="distance-input"
						className={styles.distancerange}
						type="range"
						min="10"
						max="150"
						value={!userLocation ? 150 : currentDistance}
						step="20"
						list="steplist"
						onChange={(e) =>
							onUpdateTravelDistance(Number.parseInt(e.currentTarget.value))
						}
						disabled={!userLocation}
					/>
					<datalist id="steplist">
						{DISTANCE_OPTIONS.map((option) => (
							<option key={option} value={option}>
								{option}
							</option>
						))}
					</datalist>
					<select
						className={styles.distanceselect}
						value={currentDistance}
						onChange={(e) =>
							onUpdateTravelDistance(Number.parseInt(e.currentTarget.value))
						}
						disabled={!userLocation}
						style={{}}
					>
						{!userLocation ? (
							<option>Any</option>
						) : (
							<>
								{DISTANCE_OPTIONS.map((option) => (
									<option key={option} value={option}>
										{option} miles
									</option>
								))}
							</>
						)}
					</select>
				</fieldset>
			</div>
			<Button onClick={onClick} fullWidth={true} disabled={!haveCentresInRange}>
				{centresInRange
					? `${centresInRange.length} centre(s) found`
					: "Loading..."}
			</Button>
		</div>
	);
};

export default InlineLocationFilters;
